function SectionHeading({ eyebrow, title, children, invert = false }) {
  return (
    <div className="max-w-2xl">
      <p className={invert ? 'text-xs font-black uppercase tracking-[0.24em] text-fd-line' : 'text-xs font-black uppercase tracking-[0.24em] text-fd-blue'}>{eyebrow}</p>
      <h2 className={invert ? 'mt-4 font-serif text-3xl font-black tracking-tight text-fd-paper sm:text-5xl' : 'mt-4 font-serif text-3xl font-black tracking-tight text-fd-ink sm:text-5xl'}>
        {title}
      </h2>
      {children ? <p className={invert ? 'mt-5 leading-8 text-fd-paper/78' : 'mt-5 leading-8 text-fd-stone'}>{children}</p> : null}
    </div>
  );
}

export default SectionHeading;
